import "apps/DRAW_PREDICTOR/assets/css/ui.css";

import React, {lazy, Suspense} from "react";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {projectStore} from "apps/DRAW_PREDICTOR/modules/store";
import {prepareLanguageForRouter} from "modules";
import {FAQs, Guideline, HOCi18n, NotAuthOnlyRoute, PagePreloader, Prizes, Terms} from "components";
import {Provider} from "react-redux";
import {DefaultTheme, ThemeProvider} from "styled-components";
import {theme} from "apps/DRAW_PREDICTOR/assets/css/theme";
import {helpLinks, IS_PRE_DRAW} from "apps/DRAW_PREDICTOR/modules/constants";
import {Session} from "components/Session";
import {RegistrationModal} from "apps/DRAW_PREDICTOR/components";

const Landing = lazy(() => import("apps/DRAW_PREDICTOR/pages/Landing"));
const Backdoor = lazy(() => import("pages/Backdoor"));
const NotFound = lazy(() => import("pages/NotFound"));
const Help = lazy(() => import("apps/DRAW_PREDICTOR/pages/Help"));
const PreDraw = lazy(() => import("apps/DRAW_PREDICTOR/pages/PreDraw"));
const LitePredictions = lazy(() => import("apps/DRAW_PREDICTOR/pages/LitePredictions"));

export const ProjectIndex: React.FC = () => {
	const baseName = prepareLanguageForRouter();

	return (
		<Provider store={projectStore}>
			<BrowserRouter basename={baseName}>
				<Session>
					<ThemeProvider theme={theme as unknown as DefaultTheme}>
						<HOCi18n>
							<Suspense fallback={<PagePreloader />}>
								<Routes>
									<Route
										path="/"
										element={IS_PRE_DRAW ? <PreDraw /> : <Landing />}
									/>
									{IS_PRE_DRAW ? null : (
										<Route path="/pre-draw" element={<PreDraw />} />
									)}
									<Route path="predictions" element={<LitePredictions />} />
									<Route element={<NotAuthOnlyRoute />}>
										<Route path="/backdoor" element={<Backdoor />} />
									</Route>
									<Route path="/help/*" element={<Help links={helpLinks} />}>
										<Route path="guidelines" element={<Guideline />} />
										<Route path="prizes" element={<Prizes />} />
										<Route path="faqs" element={<FAQs />} />
										<Route path="terms" element={<Terms />} />
										<Route
											path="*"
											element={<Navigate to="/help/guidelines" />}
										/>
									</Route>
									<Route path="*" element={<NotFound />} />
								</Routes>
								<RegistrationModal />
							</Suspense>
						</HOCi18n>
					</ThemeProvider>
				</Session>
			</BrowserRouter>
		</Provider>
	);
};

export default ProjectIndex;
